import { Channel } from "./Channel.js";
import { File } from "./File.js";
import { Server } from "./Server.js";
/**
 * Public Bot Class
 */
export class PublicBot {
    #client;
    id;
    username;
    avatar;
    description;
    /**
     * Construct Public Bot
     * @param client Client
     * @param data Data
     */
    constructor(client, data) {
        this.#client = client;
        this.id = data._id;
        this.username = data.username;
        this.avatar = data.avatar
            ? new File(client, {
                _id: data.avatar,
                tag: "avatars",
            })
            : undefined;
        this.description = data.description;
    }
    /**
     * Add the bot to a server
     * @param server Server
     */
    addToServer(server) {
        this.#client.api.post(`/bots/${this.id}/invite`, {
            server: server instanceof Server ? server.id : server,
        });
    }
    /**
     * Add the bot to a group
     * @param group Group
     */
    addToGroup(group) {
        // TODO: should use GroupChannel once that is added
        this.#client.api.post(`/bots/${this.id}/invite`, {
            group: group instanceof Channel ? group.id : group,
        });
    }
}
